<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="home-section-separator1"></div>
    <div class="home-section-separator2"></div>
    <div class="home-container3">
      <div class="home-hero">
        <div class="home-hero-text-container">
          <h1 class="home-heading3 Section-Heading">Atelier Brandt</h1>
          <span class="home-text10">
            Theo Brandt is de eigenaar van glas in lood atelier Brandt. Naast
            het maken van glas in lood is hij werkzaam als glaszetter. Als
            glaszetter maakt hij glas-in-lood die bij de klant en het huis past.
            In het atelier van Theo Brandt worden de mooiste ramen ontworpen en
            gemaakt. De glaszetter ontwerpt bijzondere tekeningen in
            verschillende kleuren en glassoorten. Deze glas-in-lood ramen zijn
            zowel zijn werk als hobby. Hij vindt het heerlijk om in zijn vrije
            tijd de mooiste ramen te bedenken en raakt nooit uitgekeken op zijn
            werk.
          </span>
          <div class="home-cta-btn-container">
            <router-link to="/contact" class="home-cta-btn1 Anchor button">
              <span class="home-text11">Contact</span>
            </router-link>
            <router-link to="/historie" class="home-cta-btn2 button Anchor">
              Historie
            </router-link>
          </div>
        </div>
        <img
          alt="image"
          src="/homepagineeerstefoto-1500w.png"
          class="home-image1"
        />
      </div>
    </div>
    <div class="home-features">
      <div class="home-heading-container1">
        <h2 class="home-text12 Section-Heading">Diensten</h2>
        <span class="home-text13">
          De verschillende diensten die worden uitgevoert door Theo Brandt staan
          hieronder bescheven.
        </span>
      </div>
      <div class="home-cards-container">
        <div class="home-card1">
          <div class="home-icon-container1">
            <img
              alt="image"
              src="/glas in lood/plaatsen%20laatste%20paneel-200h.jpeg"
              class="home-image2"
            />
          </div>
          <div class="home-content-container1">
            <router-link to="/glas-in-lood" class="home-heading4 Card-Heading">
              Glas In Lood
            </router-link>
            <span class="home-text14">
              Glas in lood atelier Brandt is al jaren gespecialiseerd op het
              gebied van glas in lood. Reparaties voeren wij vakkundig uit omdat
              wij precies weten wat we moeten doen. Heeft u glas in lood dat er
              niet meer zo mooi uitziet, dat begint te tochten door de
              loodnaden, dat barsten vertoont of zelfs gebroken is? Geen zorgen,
              de redding is nabij. Als u contact met ons opneemt kunnen wij u
              precies vertellen wat de mogelijkheden zijn met betrekking tot de
              reparatie van uw glas in lood raam.
            </span>
          </div>
        </div>
        <div class="home-card2">
          <div class="home-icon-container2">
            <img
              alt="image"
              src="/glaszetten/oud/effe%20opsteken%20!-200h.jpeg"
              class="home-image3"
            />
          </div>
          <div class="home-content-container2">
            <router-link to="/glaszetten" class="home-heading5 Card-Heading">
              Glaszetten
            </router-link>
            <span class="home-text15"
              >Glaszettersbedrijf Brandt is gespecialiseerd in het vervangen van
              lekke ruiten, grote ruiten plaatsen met kraan en is gediplomeerd
              en erkend glaszetter!</span
            >
          </div>
        </div>
        <div class="home-card3">
          <div class="home-icon-container3">
            <img
              alt="image"
              src="/brandschilderen/wapen2.jpg"
              class="home-image4"
            />
          </div>
          <div class="home-content-container3">
            <router-link
              to="/brandschilderen"
              class="home-heading6 Card-Heading"
            >
              Brandschilderen &amp; Fusing
            </router-link>
            <span class="home-text16">
              Glas in lood atelier Brandt maakt gebrandschilderde familie
              wapens, gemeente wapens, en past brandschilderwerk toe op glas in
              lood panelen. Qua fusing worden er naambordjes, geboorte bordjes,
              kunst objecten gemaakt, waarbij meerdere lagen glas op elkaar
              gesmolten worden en het glas gebogen kan worden!
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="home-about">
      <div class="home-max-content-width-container">
        <div class="home-heading-container2">
          <h1 class="Section-Heading home-text17">Professionele ervaring</h1>
        </div>
        <div class="home-content-container4">
          <div class="home-about11">
            <div class="home-container4">
              <svg viewBox="0 0 1024 1024" class="home-icon14">
                <path
                  d="M170 512q0-140 101-241t241-101 241 101 101 241-101 241-241 101-241-101-101-241z"
                ></path>
              </svg>
              <span class="home-text18 Card-Text">
                {{ yearsOfExperience }} jaar ervaring!
              </span>
            </div>
            <div class="home-container5">
              <svg viewBox="0 0 1024 1024" class="home-icon16">
                <path
                  d="M170 512q0-140 101-241t241-101 241 101 101 241-101 241-241 101-241-101-101-241z"
                ></path>
              </svg>
              <span class="home-text19 Card-Text">
                Gespecialiseerd in het inbouwen van glas in lood in spouwglas.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-section-separator3"></div>
    <div class="home-section-separator4"></div>
    <div class="home-section-separator5"></div>
    <div class="home-faqs">
      <h2 class="home-text27 Section-Heading">Veel gestelde vragen</h2>
      <div class="home-content-container5">
        <div class="home-faq1">
          <div class="home-question-container1">
            <span class="home-question1">
              Hoe lang duurt het voordat een project klaar is?
            </span>
          </div>
          <div class="home-answer-container1">
            <span class="home-answer1 Card-Text">
              Dit verschilt per project. Elk project is weer anders en heeft
              daarom een andere tijdsduur. Wij kunnen u wel vertellen dat wij
              altijd ons best doen om het project zo snel mogelijk af te ronden.
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="home-section-separator6"></div>
    <div class="home-section-separator7"></div>
    <div class="home-footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";

export default {
  name: "Home",
  props: {},
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      rawudt8: " ",
      baseYear: 2024,
      baseNumber: 36,
    };
  },
  metaInfo: {
    title: "Langglas",
    meta: [
      {
        property: "og:title",
        content: "Langglas",
      },
    ],
  },
  computed: {
    yearsOfExperience() {
      const currentYear = new Date().getFullYear();
      return this.baseNumber + (currentYear - this.baseYear);
    },
  },
};
</script>

<style scoped>
.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: space-between;
}
.home-heading1 {
  color: #000000;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.home-links-container1 {
  width: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-link10 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-link11 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-link12 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-link13 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-link14 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-link15 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-burger-menu {
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.home-icon10 {
  width: 36px;
  height: 36px;
}
.home-mobile-menu {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  display: none;
  padding: var(--dl-space-space-tripleunit);
  position: absolute;
  align-items: flex-start;
  flex-direction: column;
  background-color: #fff;
}
.home-container2 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.home-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-icon12 {
  width: 24px;
  height: 24px;
}
.home-links-container2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-link16 {
  margin-bottom: var(--dl-space-space-unit);
}
.home-link17 {
  margin-bottom: var(--dl-space-space-unit);
}
.home-link18 {
  margin-bottom: var(--dl-space-space-unit);
}
.home-section-separator1 {
  width: 100%;
  height: 1px;
  display: flex;
  margin-top: var(--dl-space-space-tenunits);
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-section-separator2 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-container3 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.home-hero {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  margin-top: var(--dl-space-space-fiveunits);
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-tripleunit);
  margin-bottom: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: space-between;
  background-color: #f1f1f1;
}
.home-hero-text-container {
  width: 45%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-heading3 {
  color: #040404;
  margin-bottom: var(--dl-space-space-tripleunit);
}
.home-text10 {
  color: var(--dl-color-gray-black);
  font-family: Nunito;
  margin-bottom: var(--dl-space-space-fiveunits);
}
.home-cta-btn-container {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
}
.home-cta-btn1 {
  color: var(--dl-color-gray-white);
  text-align: center;
  padding-top: var(--dl-space-space-doubleunit);
  margin-right: var(--dl-space-space-fourunits);
  padding-left: var(--dl-space-space-tenunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-tenunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  text-decoration: none;
  background-color: #ffffff;
}
.home-text11 {
  color: rgb(16, 16, 16);
}
.home-cta-btn2 {
  color: var(--dl-color-gray-black);
  text-align: center;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-tenunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-tenunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  text-decoration: none;
  background-color: var(--dl-color-gray-white);
}
.home-image1 {
  width: 40%;
  object-fit: cover;
}
.home-features {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  margin-top: var(--dl-space-space-fiveunits);
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-tripleunit);
  margin-bottom: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
}
.home-heading-container1 {
  width: 45%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fiveunits);
  flex-direction: column;
}
.home-text12 {
  margin-bottom: var(--dl-space-space-fourunits);
}
.home-text13 {
  font-size: 18px;
  text-align: center;
  font-family: Nunito;
  font-weight: 600;
  line-height: 1.55;
  letter-spacing: 2;
  text-transform: none;
  text-decoration: none;
}
.home-cards-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
}
.home-card1 {
  width: 30%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-doubleunit);
  margin-bottom: var(--dl-space-space-fourunits);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-doubleunit);
}
.home-icon-container1 {
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: center;
  border-radius: var(--dl-radius-radius-round);
  margin-bottom: var(--dl-space-space-tripleunit);
  flex-direction: column;
}
.home-image2 {
  width: auto;
  height: 100%;
  object-fit: cover;
}
.home-content-container1 {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.home-heading4 {
  margin-bottom: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-text14 {
  text-align: left;
}
.home-card2 {
  width: 30%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-doubleunit);
  margin-bottom: var(--dl-space-space-fourunits);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-doubleunit);
}
.home-icon-container2 {
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: center;
  border-radius: var(--dl-radius-radius-round);
  margin-bottom: var(--dl-space-space-tripleunit);
  flex-direction: column;
}
.home-image3 {
  width: auto;
  height: auto;
  object-fit: cover;
}
.home-content-container2 {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.home-heading5 {
  margin-bottom: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.home-text15 {
  text-align: left;
}
.home-card3 {
  width: 30%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-doubleunit);
  margin-bottom: var(--dl-space-space-fourunits);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-doubleunit);
}
.home-icon-container3 {
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: center;
  border-radius: var(--dl-radius-radius-round);
  margin-bottom: var(--dl-space-space-tripleunit);
  flex-direction: column;
}
.home-image4 {
  width: 267px;
  height: 100%;
  object-fit: cover;
}
.home-content-container3 {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.home-heading6 {
  margin-bottom: var(--dl-space-space-tripleunit);
}
.home-text16 {
  text-align: left;
}
.home-about {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-fourunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fourunits);
  justify-content: center;
  background-color: var(--dl-color-gray-900);
}
.home-max-content-width-container {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  margin-top: var(--dl-space-space-fiveunits);
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-tripleunit);
  margin-bottom: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
}
.home-heading-container2 {
  width: 45%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fiveunits);
  flex-direction: column;
}
.home-content-container4 {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: row;
  justify-content: center;
}
.home-about11 {
  width: 65%;
  display: flex;
  padding: var(--dl-space-space-fourunits);
  align-self: stretch;
  align-items: flex-start;
  border-radius: var(--dl-radius-radius-radius4);
  flex-direction: row;
  justify-content: space-between;
  background-color: var(--dl-color-gray-900);
}
.home-container4 {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: center;
}
.home-icon14 {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
.home-text18 {
  text-align: left;
  font-size: 22px !important;
}
.home-container5 {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: center;
}
.home-icon16 {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
.home-text19 {
  text-align: left;
  font-size: 22px !important;
}
.home-container6 {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: center;
}
.home-icon18 {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
.home-text20 {
  text-align: left;
  font-size: 22px !important;
}
.home-about12 {
  width: 30%;
  display: flex;
  padding: var(--dl-space-space-fourunits);
  align-self: stretch;
  align-items: flex-start;
  border-radius: var(--dl-radius-radius-radius4);
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--dl-color-gray-900);
}
.home-container7 {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: center;
}
.home-icon20 {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
.home-text21 {
  text-align: left;
  font-size: 22px !important;
}
.home-container8 {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: center;
}
.home-icon22 {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
.home-text25 {
  text-align: left;
  font-size: 22px !important;
}
.home-container9 {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: center;
}
.home-icon24 {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
.home-text26 {
  text-align: left;
  font-size: 22px !important;
}
.home-button {
  color: var(--dl-color-gray-white);
  text-align: center;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-tenunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-tenunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  background-color: var(--dl-color-gray-black);
}
.home-section-separator3 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-section-separator4 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-section-separator5 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-faqs {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  margin-top: var(--dl-space-space-fiveunits);
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-tripleunit);
  margin-bottom: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: flex-start;
}
.home-text27 {
  margin-bottom: var(--dl-space-space-fourunits);
}
.home-content-container5 {
  width: 100%;
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.home-faq1 {
  width: 85%;
  display: flex;
  align-items: flex-start;
  border-color: var(--dl-color-gray-900);
  border-width: 1px;
  border-radius: var(--dl-radius-radius-radius8);
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
.home-question-container1 {
  width: 100%;
  align-self: center;
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-fourunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-fourunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  background-color: var(--dl-color-gray-900);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.home-question1 {
  font-size: 18px;
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
}
.home-answer-container1 {
  display: flex;
  padding: var(--dl-space-space-fourunits);
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
  border-radius: var(--dl-radius-radius-radius8);
  flex-direction: column;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.home-answer1 {
  margin-bottom: var(--dl-space-space-unit);
}
.home-faq2 {
  width: 85%;
  display: flex;
  align-items: flex-start;
  border-color: var(--dl-color-gray-900);
  border-width: 1px;
  border-radius: var(--dl-radius-radius-radius8);
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
.home-question-container2 {
  width: 100%;
  align-self: center;
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-fourunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-fourunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  background-color: var(--dl-color-gray-900);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.home-question2 {
  font-size: 18px;
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
}
.home-answer-container2 {
  display: flex;
  padding: var(--dl-space-space-fourunits);
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
  border-radius: var(--dl-radius-radius-radius8);
  flex-direction: column;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.home-answer3 {
  margin-bottom: var(--dl-space-space-unit);
}
.home-faq3 {
  width: 85%;
  display: flex;
  align-items: flex-start;
  border-color: var(--dl-color-gray-900);
  border-width: 1px;
  border-radius: var(--dl-radius-radius-radius8);
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
.home-question-container3 {
  width: 100%;
  align-self: center;
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-fourunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-fourunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  background-color: var(--dl-color-gray-900);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.home-question3 {
  font-size: 18px;
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
}
.home-answer-container3 {
  display: flex;
  padding: var(--dl-space-space-fourunits);
  font-style: normal;
  font-family: Open Sans;
  font-weight: 700;
  border-radius: var(--dl-radius-radius-radius8);
  flex-direction: column;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.home-answer5 {
  margin-bottom: var(--dl-space-space-unit);
}
.home-section-separator6 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-section-separator7 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}
.home-footer {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: center;
}
.home-copyright-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-icon26 {
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
@media (max-width: 1600px) {
  .home-navbar {
    width: 100%;
  }
  .home-footer {
    justify-content: center;
  }
}
@media (max-width: 1200px) {
  .home-navbar {
    width: 100%;
  }
  .home-heading1 {
    margin-right: var(--dl-space-space-fourunits);
  }
  .home-links-container1 {
    width: auto;
    position: relative;
  }
  .home-link10 {
    width: auto;
    height: auto;
  }
  .home-link11 {
    width: auto;
    height: auto;
  }
  .home-link12 {
    width: auto;
    height: auto;
  }
  .home-link13 {
    width: auto;
    height: auto;
  }
  .home-link14 {
    width: auto;
  }
  .home-link15 {
    width: auto;
  }
}
@media (max-width: 991px) {
  .home-heading1 {
    text-align: center;
  }
  .home-links-container1 {
    width: 424px;
    display: none;
  }
  .home-link10 {
    width: auto;
    height: auto;
  }
  .home-link11 {
    width: auto;
    height: auto;
  }
  .home-link12 {
    width: auto;
    height: auto;
  }
  .home-link13 {
    width: auto;
    height: auto;
  }
  .home-link14 {
    width: auto;
    height: auto;
  }
  .home-link15 {
    width: auto;
    height: auto;
  }
  .home-burger-menu {
    display: flex;
  }
  .home-heading2 {
    text-align: center;
  }
  .home-hero {
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .home-hero-text-container {
    width: 80%;
    align-items: center;
    margin-bottom: var(--dl-space-space-fourunits);
  }
  .home-heading3 {
    text-align: center;
  }
  .home-text10 {
    text-align: center;
  }
  .home-image1 {
    width: 100%;
  }
  .home-text12 {
    text-align: center;
  }
}
@media (max-width: 767px) {
  .home-navbar {
    position: relative;
  }
  .home-links-container1 {
    display: none;
  }
  .home-burger-menu {
    display: flex;
    padding: var(--dl-space-space-halfunit);
    margin-left: var(--dl-space-space-tripleunit);
    border-radius: var(--dl-radius-radius-radius4);
    background-color: var(--dl-color-gray-black);
  }
  .home-icon10 {
    fill: var(--dl-color-gray-white);
  }
  .home-cta-btn1 {
    padding-left: var(--dl-space-space-fourunits);
    padding-right: var(--dl-space-space-fourunits);
  }
  .home-cta-btn2 {
    padding-left: var(--dl-space-space-fourunits);
    padding-right: var(--dl-space-space-fourunits);
  }
  .home-heading-container1 {
    width: 100%;
  }
  .home-cards-container {
    align-items: center;
    flex-direction: column;
  }
  .home-card1 {
    width: 70%;
    margin-bottom: var(--dl-space-space-tripleunit);
  }
  .home-card2 {
    width: 70%;
    margin-bottom: var(--dl-space-space-tripleunit);
  }
  .home-card3 {
    width: 70%;
    margin-bottom: var(--dl-space-space-tripleunit);
  }
  .home-heading-container2 {
    width: 100%;
  }
  .home-text17 {
    text-align: center;
  }
  .home-content-container4 {
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
  }
  .home-about11 {
    width: 65%;
  }
  .home-about12 {
    width: 65%;
  }
  .home-content-container5 {
    width: 100%;
    flex-direction: column;
  }
  .home-faq1 {
    width: 100%;
  }
  .home-faq2 {
    width: 100%;
  }
  .home-faq3 {
    width: 100%;
  }
}
@media (max-width: 479px) {
  .home-burger-menu {
    margin-left: var(--dl-space-space-doubleunit);
  }
  .home-hero-text-container {
    width: 100%;
  }
  .home-card1 {
    width: 100%;
  }
  .home-card2 {
    width: 100%;
  }
  .home-card3 {
    width: 100%;
  }
  .home-about11 {
    width: 100%;
  }
  .home-about12 {
    width: 100%;
  }
  .home-content-container5 {
    padding-left: 0px;
  }
}
</style>
